export const tags = [
  "jnct-lti-lms",
  "jnct-lti-add-course",
  "jnct-lti-pair-course-view",
  "jnct-lti-course-view",
  "jnct-lti-unpair-course-modal",
  "jnct-lti-student-view",
] as const;
